/**
 * Cliente da tela Localização (#229) + estado puro do banner (ADR-0014).
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, put, post } from './client.js'

export type AdminLocation = {
  confirmed: boolean
  pending: boolean
  needs_setup: boolean
  location: {
    formatted_address: string
    place_id: string | null
    lat: number | null
    lng: number | null
    city: string | null
    country_code: string | null
    source: string
  } | null
  place: {
    id: string
    google_place_id: string | null
    name: string
    formatted_address: string
    lat: number | null
    lng: number | null
    maps_url: string
    status: 'suggestion' | 'confirmed'
    location_source: string
    location_confidence: number | null
    location_verified_at: number | null
  } | null
  maps_url: string | null
}

export type PlacesSuggestion = { place_id: string; label: string; secondary: string | null }

export type ResolvedPlace = {
  place_id: string
  name: string
  formatted_address: string
  lat: number | null
  lng: number | null
  maps_url: string
  components: {
    country_code: string | null
    street: string | null
    postal_code: string | null
    city: string | null
  }
}

export type LocationUpdateAddress = {
  formatted: string
  name?: string | undefined
  place_id?: string | undefined
  lat?: number | undefined
  lng?: number | undefined
  country?: string | undefined
  street?: string | undefined
  postal_code?: string | undefined
  city?: string | undefined
  source: 'places' | 'manual' | 'owner_pin'
}

/**
 * Session token do Places (#394): obrigatório no autocomplete (emite a
 * sessão no servidor) e reenviado no resolve (que a consome — 1 por
 * sessão). Novo token a cada sessão de busca.
 */
export function newPlacesSession(): string {
  return crypto.randomUUID()
}

export const locationApi = {
  get: () => get<AdminLocation>('/admin/location'),
  confirmSuggestion: () => put<AdminLocation>('/admin/location', { action: 'confirm_suggestion' }),
  update: (address: LocationUpdateAddress) =>
    put<AdminLocation>('/admin/location', { address, confirm: true }),
  autocomplete: (query: string, session: string) => {
    const qs = new URLSearchParams({ query, session })
    return get<{ suggestions: PlacesSuggestion[] }>(`/places/autocomplete?${qs.toString()}`)
  },
  resolve: (placeId: string, session: string) =>
    post<{ place: ResolvedPlace }>('/places/resolve', { place_id: placeId, session }),
}

/** Estado do banner (puro, testável): o que mostrar ao dono. */
export type LocationBannerState =
  { kind: 'hidden' } | { kind: 'confirm_suggestion' } | { kind: 'missing' }

export function locationBannerState(loc: AdminLocation | null | undefined): LocationBannerState {
  if (!loc || loc.confirmed) return { kind: 'hidden' }
  if (loc.pending) return { kind: 'confirm_suggestion' }
  return { kind: 'missing' }
}
